// Module
var code = `<div class="option-calculator-screen">
    <div class="option-calculator-screen-container">
        <div class="option-calculator-screen-header-container">
            <div class="option-calculator-screen-header input-parameters">
                {{inputParametersLabel}}
            </div>
            <div class="option-calculator-screen-header output-parameters">
                {{outputParametersLabel}}
            </div>
        </div>
        <div class="option-calculator-screen-body-container">
            <div class="option-calculator-screen-body input-parameters">
                <div class="input-parameters-container">
                    <div class="input-parameters-container-row">
                        <div class="input-parameters-group-buttons-label">{{isIVChecked ? impliedVolatilityInputLabel : theoreticalPriceInputLabel}}</div> 
                        <terceraGroupButtons name="inputParametersGroupButtons" buttonsInfo="{{inputParametersGroupButtonsInfo}}" on-groupBtnClick="inputParametersGroupButtons_btnClick" tooltip="{{OP_IV_tt}}"/>
                    </div>
                    <div class ="input-parameters-container-row">
                        <terceraLabel text="{{strikePriceLabel}}" />
                        <terceraNumeric name="strikePriceNumeric" value="{{strikePrice}}" minValue="0.00001" step="0.00001" decimalPrecision="5"/>
                    </div>
                    <div class ="input-parameters-container-row">
                        <terceraLabel text="{{underlyingPriceLabel}}" />
                        <terceraNumeric name="underlyingPriceNumeric" value="{{underlyingPrice}}" minValue="0.00001" step="0.00001" decimalPrecision="5"/>
                    </div>
                    <div class ="input-parameters-container-row">
                        <terceraLabel text="{{impliedVolatilityLabel}}" />
                        <terceraNumeric name="impliedVolatilityNumeric" value="{{impliedVolatility}}" enabled="{{!isIVChecked}}" minValue="0.00001" step="0.00001" decimalPrecision="5"/>
                    </div>
                    <div class ="input-parameters-container-row">
                        <terceraLabel text="{{optionPriceLabel}}" />
                        <terceraNumeric name="optionPriceNumeric" value="{{optionPrice}}" enabled="{{isIVChecked}}" minValue="0.00001" step="0.00001" decimalPrecision="5"/>
                    </div>
                    <div class ="input-parameters-container-row">
                        <terceraLabel text="{{interestRateLabel}}" />
                        <terceraNumeric name="interestRateNumeric" value="{{interestRate}}" minValue="0.00001" step="0.00001" decimalPrecision="5"/>
                    </div>
                    <div class ="input-parameters-container-row">
                        <terceraLabel text="{{daysTillExpirationLabel}}" />
                        <terceraNumeric name="daysTillExpirationNumeric" value="{{daysTillExpiration}}" minValue="1" step="1" decimalPrecision="0"/>
                    </div>
                    <div class="input-parameters-container-row button-container">
                        <terceraButton name="calculateButton" text="{{calculateButtonText}}" terceraButtonStyle="js-button-blue" on-btnClick="calculateBtnClick" />
                        <terceraButton name="resetButton" text="{{resetButtonText}}" terceraButtonStyle="js-button-blue" on-btnClick="resetBtnClick" tooltip="{{resetButtonText_tt}}"/>
                    </div>
                </div>
            </div>
            <div class="option-calculator-screen-body output-parameters">
                <div class="table">
                    <div class="row">
                        <div class="col header"></div>
                        <div class="col header">
                            <div class="text">{{putLabel}}</div>
                        </div>
                        <div class="col header">
                            <div class="text">{{callLabel}}</div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="text">{{deltaLabel}}</div>
                        </div>
                        <div class="col">
                            <div class="text">{{putDelta}}</div>
                        </div>
                        <div class="col">
                            <div class="text">{{callDelta}}</div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="text">{{gammaLabel}}</div>
                        </div>
                        <div class="col">
                            <div class="text">{{putGamma}}</div>
                        </div>
                        <div class="col">
                            <div class="text">{{callGamma}}</div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="text">{{vegaLabel}}</div>
                        </div>
                        <div class="col">
                            <div class="text">{{putVega}}</div>
                        </div>
                        <div class="col">
                            <div class="text">{{callVega}}</div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="text">{{impliedVolatilityLabel}}</div>
                        </div>
                        <div class="col">
                            <div class="text">{{putImpliedVolatility}}</div>
                        </div>
                        <div class="col">
                            <div class="text">{{callImpliedVolatility}}</div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="text">{{thetaLabel}}</div>
                        </div>
                        <div class="col">
                            <div class="text">{{putTheta}}</div>
                        </div>
                        <div class="col">
                            <div class="text">{{callTheta}}</div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="text">{{rhoLabel}}</div>
                        </div>
                        <div class="col">
                            <div class="text">{{putRho}}</div>
                        </div>
                        <div class="col">
                            <div class="text">{{callRho}}</div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="text">{{theoreticalPriceLabel}}</div>
                        </div>
                        <div class="col">
                            <div class="text">{{putTheoreticalPrice}}</div>
                        </div>
                        <div class="col">
                            <div class="text">{{callTheoreticalPrice}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>`;
// Exports
export default code;